import { useEffect, useState } from "react";
import { formatDecimal } from "../../../../utils/NumberFunctions/decimal.formatter";

const TaxAmount = (props) => {
  const { items } = props;
  const [igstTaxes, setIgstTaxes] = useState({});
  const [cgstSgstTaxes, setCgstSgstTaxes] = useState({});

  useEffect(() => {
    let igst = {};
    let cgst_sgst = {};

    items?.map((item) => {
      if (item?.tax_type == "igst") {
        if (!igst[item?.tax_value]) {
          igst[item?.tax_value] = 0;
        }
        igst[item?.tax_value] +=
          (item.quantity *
            (item.unit_po_price -
              (item.discount ?? 0) * item.unit_po_price * 0.01) *
            item?.tax_value) /
          100;
      }
      if (item?.tax_type == "cgst_sgst") {
        if (!cgst_sgst[item?.tax_value]) {
          cgst_sgst[item?.tax_value] = 0;
        }
        cgst_sgst[item?.tax_value] +=
          (item.quantity *
            (item.unit_po_price -
              (item.discount ?? 0) * item.unit_po_price * 0.01) *
            item?.tax_value) /
          100;
      }
    });
    setIgstTaxes(igst);
    setCgstSgstTaxes(cgst_sgst);
  }, [items]);

  const getDiv = () => {
    const divs = [];
    Object.keys(igstTaxes).forEach((key, index) => {
      console.log("Hello", key);
      divs.push(
        <div className="d-flex justify-content-between" key={index}>
          <div className="">IGST {key}% </div>
          <div className="">₹ {formatDecimal(igstTaxes[key])}</div>
        </div>
      );
    });

    Object.keys(cgstSgstTaxes).forEach((key, index) => {
      console.log("Hello", key);
      divs.push(
        <>
          <div className="d-flex justify-content-between" key={index}>
            <div className="">CGST {key / 2}% </div>
            <div className="">₹ {(cgstSgstTaxes[key] / 2)?.toFixed(2)}</div>
          </div>
          <div className="d-flex justify-content-between" key={index}>
            <div className="">SGST {key / 2}% </div>
            <div className="">₹ {(cgstSgstTaxes[key] / 2)?.toFixed(2)}</div>
          </div>
        </>
      );
    });

    return divs;
  };
  return <>{getDiv()}</>;
};

export default TaxAmount;
